/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';


import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import { listProjects } from '../../modules/techModule/projects';
import ProjectList from '../../components/techmng/ProjectList';
import TechStatusList from '../../components/techmng/info/TechStatusList';
import TechStatusChip from '../../components/common/datagrid/TechStatusChip';
import { ProjectListBox } from '../../components/techmng/ProjectListBox';
import { getNumberComma } from '../../utils/numberUtils';
import { getDefaultSearchRange } from '../../utils/defaultSearchRange';

const ProjectListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  // 검색 시작일/종료일을 비워두지 않고 오늘 기준 앞뒤 1년을 기본 조회범위로 둔다.
  const defaultRange = getDefaultSearchRange();

  const [searchGrade, setSearchGrade] = useState("");
  const [searchPrjImpt, setSearchPrjImpt] = useState("");
  const [searchPrjTyp, setSearchPrjTyp] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("cstNm");
  const [searchWords, setSearchWords] = useState(null);
  const [searchStrtDt, setSearchStrtDt] = useState(defaultRange.searchStrtDt);
  const [searchEndDt, setSearchEndDt] = useState(defaultRange.searchEndDt)

  const { projects, error, loading } = useSelector(
    ({ techModule, loading }) => ({
      projects: techModule.projects.projects,
      error: techModule.projects.error,
      loading: loading['tech/LIST_PROJECTS'],
    }),
  );

  // // 컴포넌트 마운트 후 list 데이터 요청
  // useEffect(() => {
  //   dispatch(listProjects());
  // }, []);

  const searchList = (values) => {

    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      prjTyp: searchPrjTyp,
      techGrade: searchGrade,
      prjImpt: values.searchPrjImpt,
      [searchKeyword]: values.searchWords,
      strtDt: startDate,
      endDt: endDate,
    };

    setSearchPrjImpt(values.searchPrjImpt)
    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    dispatch(listProjects(searchData));

  }

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'prjTyp',
        headerName: '프로젝트 타입',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value) => (value === 'M' ? '유지보수' : '프로젝트'),
        renderCell: (params) => {
          return (params.value === 'M') ? '유지보수' : '프로젝트'
        }
      },

      {
        field: 'partnerInc',
        headerName: '고객명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 200,
        flex: 1,
        description: '',
        editable: false,
      },
      {
        field: 'totalSales',
        headerName: '총매출액',
        minWidth: 150,
        flex: 1,
        description: '',
        align: 'center',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (value) => getNumberComma(value),
        renderCell: (params) => (getNumberComma(params.value))
      },
      {
        field: 'totalPurchase',
        headerName: '총매입액',
        minWidth: 150,
        flex: 1,
        description: '',
        align: 'center',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (value) => getNumberComma(value),
        renderCell: (params) => (getNumberComma(params.value))
      },
      {
        field: 'totalProfit',
        headerName: '매출이익',
        minWidth: 150,
        flex: 1,
        description: '',
        align: 'center',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (value) => getNumberComma(value),
        renderCell: (params) => (getNumberComma(params.value))
      },
      {
        field: 'techStatus',
        headerName: '상태',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        align: 'center',
        headerAlign: 'center',
        editable: false,
        renderCell: TechStatusChip,
      },

      {
        field: 'crtDptNm',
        headerName: '부서',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtNm',
        headerName: '영업담당자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        valueGetter: (_, row) => `${row?.crtNm || ''} ${row?.crtGradeNm || ''}`.trim(),
        renderCell: (params) => (
          <div>
            {params.row.crtNm} {params.row.crtGradeNm}
          </div>
        ),
      },
      {
        field: 'prjNo',
        headerName: '프로젝트 번호',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        // renderCell: (params) => (
        //   params.row.prjNo
        // ),
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    //let techGrade = (param.row.techGrade && parseInt(param.row.techGrade) !== 0) ? param.row.techGrade : 1;
    navigate(`/techmng/${param.id}/${param.row.techGrade}/1`);
  };


  const initialValues = {
    searchPrjImpt: searchPrjImpt,
    searchKeyword: searchKeyword,
    searchWords: searchWords,
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };


  const validationSchema = yup.object({
    searchPrjImpt: yup.string().nullable(),
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '등록 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('등록 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  useEffect(() => {
    searchList(formik.values);
  }, [searchGrade, searchPrjTyp,])

  const onChangeGrade = (grade) => {
    if (grade === searchGrade) {
      grade = "";
    }
    setSearchGrade(grade);
  }

  const onChangePrjTyp = (type) => {
    if (type === searchPrjTyp) {
      type = "";
    }
    setSearchPrjTyp(type);
  }
  return (
    <>
      <BreadcrumbsContainer title="기술지원/기술 지원 관리/프로젝트 리스트" icon="tech" />
      <ProjectListBox formik={formik} />
      <TechStatusList searchGrade={searchGrade} onChangeGrade={onChangeGrade} searchPrjTyp={searchPrjTyp} onChangePrjTyp={onChangePrjTyp} />
      <ProjectList
        apiRef={apiRef}
        columns={columns}
        rows={projects}
        error={error}
        loading={loading}
        handleRowClick={handleRowClick}
        columnVisibilityModel={{
          id: false,
        }}
      />
    </>
  );
};

export default ProjectListContainer;
